import React, { useState, useEffect } from 'react';
import { Table, Button, Tag, message, Popconfirm, Card } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined, VideoCameraOutlined } from '@ant-design/icons';
import useCompanyNavigate from '../../utils/useCompanyNavigate';
import { ys7DeviceApi } from '../../services/api';

const Ys7Devices = () => {
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const navigate = useCompanyNavigate();

  useEffect(() => {
    fetchList();
  }, []);

  const fetchList = async () => {
    setLoading(true);
    try {
      const res = await ys7DeviceApi.list();
      if (res.code === 200) {
        setList(res.data);
      }
    } catch (err) {
      console.error('获取设备列表失败:', err);
      message.error('获取设备列表失败');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      await ys7DeviceApi.delete(id);
      message.success('删除成功');
      fetchList();
    } catch (err) {
      message.error(err.message || '删除失败');
    }
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      width: 60,
    },
    {
      title: '设备名称',
      dataIndex: 'name',
    },
    {
      title: 'AppKey',
      dataIndex: 'appkey',
      ellipsis: true,
    },
    {
      title: '设备序列号',
      dataIndex: 'device_serial',
      ellipsis: true,
    },
    {
      title: '通道号',
      dataIndex: 'channel_no',
      width: 80,
    },
    {
      title: '协议',
      dataIndex: 'protocol_type',
      width: 80,
      render: (val) => {
        const colorMap = {
          'hls': 'blue',
          'rtmp': 'green',
          'flv': 'orange',
          'ezopen': 'purple'
        };
        return <Tag color={colorMap[val] || 'default'}>{val}</Tag>;
      }
    },
    {
      title: '状态',
      dataIndex: 'is_active',
      width: 80,
      render: (val) => (
        <Tag color={val === 1 ? 'green' : 'red'}>
          {val === 1 ? '启用' : '禁用'}
        </Tag>
      ),
    },
    {
      title: '排序',
      dataIndex: 'sort_order',
      width: 80,
    },
    {
      title: '操作',
      key: 'action',
      width: 150,
      render: (_, record) => (
        <>
          <Button
            type="link"
            size="small"
            icon={<EditOutlined />}
            onClick={() => navigate(`/admin/ys7-devices/${record.id}/edit`)}
          >
            编辑
          </Button>
          <Popconfirm
            title="确定删除此设备吗？"
            onConfirm={() => handleDelete(record.id)}
            okText="确定"
            cancelText="取消"
          >
            <Button type="link" size="small" danger icon={<DeleteOutlined />}>
              删除
            </Button>
          </Popconfirm>
        </>
      ),
    },
  ];

  return (
    <div>
      <Card>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
          <h2>
            <VideoCameraOutlined style={{ marginRight: 8 }} />
            监控设备管理
          </h2>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => navigate('/admin/ys7-devices/new')}
            style={{ background: '#8B7355' }}
          >
            新增设备
          </Button>
        </div>

        <Table
          columns={columns}
          dataSource={list}
          rowKey="id"
          loading={loading}
          pagination={false}
        />
      </Card>
    </div>
  );
};

export default Ys7Devices;
